<div class="field-time-wrapper">
  <div class="time-ans" *ngIf="!isInput">
    {{timeDisplay}}
  </div>

  <div class="time-input time-picker-wrapper" *ngIf="isInput">
    <timepicker [(ngModel)]="timeInput" (ngModelChange)="onChange()"></timepicker>
    <i class="fa fa-fw fa-clock-o text-color-primary" (click)="setCurrentTime()"></i>
  </div>
</div>